/* eslint-disable max-lines-per-function */

import { FristenMobile } from '@/domain/mitarbeiter/features/anlageassistent/content/Anstellungsverhaeltnis/Fristen/FristenMobile/FristenMobile';
import { FristenTable } from '@/domain/mitarbeiter/features/anlageassistent/content/Anstellungsverhaeltnis/Fristen/FristenTable/FristenTable';
import { useAnlageassistentContext } from '@/domain/mitarbeiter/features/anlageassistent/context/useAnlageassistentContext';
import {
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
  Body,
  Button,
  DataDisplayPlain,
  Heading,
  Separator,
  Title,
} from '@e2n/ui/v2';

import { useAnlageassistentFormContext } from '@/domain/mitarbeiter/features/anlageassistent/context/AnlageassistentFormContext';
import { formatDate } from '@/domain/mitarbeiter/features/anlageassistent/utils/formatDate';
import { faPen } from '@fortawesome/pro-regular-svg-icons';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslation } from 'react-i18next';

export function Anstellungsverhaeltnis() {
  const { t } = useTranslation();
  const { ctx } = useAnlageassistentContext();
  const form = useAnlageassistentFormContext();

  const data = form.state.values;

  return (
    <AccordionItem value="anstellungsverhaeltnis" className="border-none">
      <AccordionTrigger>
        <Heading className="ml-2">
          {t('domain.mitarbeiter.create.steps.anstellungsverhaeltnis.title')}
        </Heading>
      </AccordionTrigger>
      <AccordionContent>
        <div className="py-4">
          <div className="flex items-center">
            <Title>
              {t(
                'domain.mitarbeiter.create.steps.anstellungsverhaeltnis.anstellung.title',
              )}
            </Title>
            <Button
              className="ml-auto"
              iconOnly
              variant={'secondary-red'}
              onClick={() =>
                ctx.navigateToSubStep('anstellungsverhaeltnis.anstellung')
              }>
              <FontAwesomeIcon icon={faPen} />
            </Button>
          </div>

          <div className="flex flex-col gap-4">
            <DataDisplayPlain
              orientation="horizontal"
              variant="text"
              label={t(
                'domain.mitarbeiter.create.steps.anstellungsverhaeltnis.anstellung.form.anstellungstyp.label',
              )}
              item={t(
                'domain.mitarbeiter.create.steps.anstellungsverhaeltnis.anstellung.form.anstellungstyp.options.' +
                  data.anstellungsverhaeltnis.anstellung.anstellungstyp,
              )}
            />
            <DataDisplayPlain
              orientation="horizontal"
              variant="text"
              label={t(
                'domain.mitarbeiter.create.steps.anstellungsverhaeltnis.anstellung.form.eintrittsdatum.label',
              )}
              item={formatDate(
                data.anstellungsverhaeltnis.anstellung.eintrittsdatum,
              )}
            />
            <DataDisplayPlain
              orientation="horizontal"
              variant="text"
              label={t(
                'domain.mitarbeiter.create.steps.anstellungsverhaeltnis.anstellung.form.befristetBis.label',
              )}
              item={formatDate(
                data.anstellungsverhaeltnis.anstellung.befristung,
              )}
            />
          </div>
        </div>
        <Separator />
        <div className="py-4">
          <div className="flex items-center">
            <Title>
              {t(
                'domain.mitarbeiter.create.steps.anstellungsverhaeltnis.fristen.title',
              )}
            </Title>
            <Button
              className="ml-auto"
              iconOnly
              variant={'secondary-red'}
              onClick={() =>
                ctx.navigateToSubStep('anstellungsverhaeltnis.fristen')
              }>
              <FontAwesomeIcon icon={faPen} />
            </Button>
          </div>
          <FristenTable readonly />
          <FristenMobile readonly />
          {data.anstellungsverhaeltnis.fristen.length === 0 && (
            <Body className="text-labels-secondary py-2">
              {t('domain.mitarbeiter.create.general.keineAuswahl')}
            </Body>
          )}
        </div>
      </AccordionContent>
    </AccordionItem>
  );
}
